import { render } from "./ViewUsager.vue?vue&type=template&id=53bab22a&scoped=true&ts=true"
import script from "./ViewUsager.vue?vue&type=script&lang=ts"
export * from "./ViewUsager.vue?vue&type=script&lang=ts"

import "./ViewUsager.vue?vue&type=style&index=0&id=53bab22a&scoped=true&lang=css"
import "./ViewUsager.vue?vue&type=style&index=1&id=53bab22a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bab22a"]])

export default __exports__